import { ActionTree } from 'vuex';
import { PostgradContractExtensionState } from './state';
import { CourseModel } from '@descomplica/dex-models';
import { ChimeraCourseModel } from '@/models/chimera/ChimeraCourseModel';
import RootState from '@/store/root_state';
import ContractExtensionRequestService from '@/helpers/postgradContractExtension/request';
import { getDexToken } from '@/helpers/get-tokens';

const actions: ActionTree<PostgradContractExtensionState, RootState> = {
  async GET_POSTGRAD_CONTRACT_EXTENSION_ELIGIBILITY(
    { commit, getters },
    { course, chimeraCourse }: { course: CourseModel; chimeraCourse: ChimeraCourseModel | null },
  ) {
    const token = getDexToken();

    if (!token || !chimeraCourse || !getters.canViewPostgradContractExtensionButton) return;

    const chimeraContractId =
      chimeraCourse.contractByUser?.id || chimeraCourse.mostRecentExpiredCourseContract?.id;

    if (!chimeraContractId) return;

    const eligibilityInfo =
      await ContractExtensionRequestService.getContractExtensionEligibilityInfo({
        course,
        chimeraContractId: +chimeraContractId,
        token,
      });

    commit('SET_POSTGRAD_CONTRACT_EXTENSION_ELIGIBILITY', {
      courseId: course.id,
      eligibilityInfo,
    });
  },
};

export default actions;
